import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ClipboardCheck } from 'lucide-react';
import { CONTROL_META, StatusBadge } from './fleetUtils';
import ChecklistDialog from './ChecklistDialog';

const Section = ({ title, items, badgeCls, onStart }) => (
  <div>
    <h3 className="font-semibold text-sm mb-2">{title} ({items.length})</h3>
    {items.length === 0 ? <p className="text-xs text-gray-400 mb-3">Aucun véhicule</p> : (
      <div className="space-y-2 mb-4">
        {items.map((v) => (
          <Card key={v.vehicle_id} data-testid={`control-row-${v.vehicle_id}`}>
            <CardContent className="p-3 flex flex-wrap items-center justify-between gap-2">
              <div>
                <p className="font-mono font-bold">{v.plate_number} <span className="font-sans font-normal text-sm text-gray-500">{v.brand} {v.model}</span></p>
                <p className="text-xs text-gray-500">
                  Dernier contrôle : {v.last_inspection ? `${v.last_inspection.week_key} par ${v.last_inspection.admin_name || ''}` : 'Jamais'}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <StatusBadge status={v.operational_status} />
                <span className={`text-xs px-2 py-1 rounded ${badgeCls}`}>{CONTROL_META[v.control_status]?.label}</span>
                {onStart && (
                  <Button size="sm" onClick={() => onStart(v)} data-testid={`start-control-${v.vehicle_id}`}>
                    <ClipboardCheck className="w-4 h-4 mr-1" /> Commencer le contrôle
                  </Button>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    )}
  </div>
);

const ControlsTab = ({ onRefreshParc }) => {
  const [summary, setSummary] = useState(null);
  const [checkVehicle, setCheckVehicle] = useState(null);

  const load = async () => {
    try {
      const res = await axios.get(`${API}/fleet/controls/summary`, { withCredentials: true });
      setSummary(res.data);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => { load(); }, []);

  if (!summary) return <p className="text-sm text-gray-500">Chargement...</p>;

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-600"><strong>Contrôle périodique complet (70 points)</strong> — Semaine en cours : <strong>{summary.week_key}</strong> (lundi 00:00 → dimanche 23:59, heure de Paris). Distinct du contrôle quotidien rapide.</p>
      <Section title="🔴 Contrôles en retard" items={summary.overdue} badgeCls={CONTROL_META.en_retard.cls} onStart={setCheckVehicle} />
      <Section title="🔵 À faire cette semaine" items={summary.todo} badgeCls={CONTROL_META.a_faire.cls} onStart={setCheckVehicle} />
      <Section title="🟢 Réalisés cette semaine" items={summary.done} badgeCls={CONTROL_META.realise.cls} onStart={null} />
      <ChecklistDialog vehicle={checkVehicle} open={!!checkVehicle}
        onClose={() => setCheckVehicle(null)}
        onValidated={() => { load(); onRefreshParc?.(); }} />
    </div>
  );
};

export default ControlsTab;
